import {
  // patient space
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USERS_RESET,
  // medecin PS
  MEDECIN_PS_LOGIN_REQUEST,
  MEDECIN_PS_LOGIN_SUCCESS,
  MEDECIN_PS_LOGIN_FAIL,
  MEDECIN_PS_LOGOUT,
  MEDECIN_PS_DETAIL_RESET,
  MEDECIN_PS_RESET,
} from "../constants/user_constant";

import {
  DEPOT_ALL_RESET,
  PDF_RESET,
  PDFMPS_RESET,
} from "../constants/depot_constant";
import axios from "axios";
import { BASE_URL } from "../axios/serverURL";

// patient
export const login = (id_depot, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "auth",
      action: "loginPatient",
      id_depot: id_depot,
      password: password,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    // console.log("data", data);
    if (data.success !== false) {
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: data,
      });
      localStorage.setItem("userInfo", JSON.stringify(data));
      localStorage.setItem("token", JSON.stringify(data.token));
    } else {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: data.error,
      });
    }
  } catch (error) {
    console.log("error", error);
    console.log(error);
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const logout = () => async (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("token");
  const inputs = {
    headers: {
      "Content-type": "application/json",
    },
    object: "auth",
    action: "logoutPatient",
  };

  const { data } = await axios.post(BASE_URL, inputs);

  dispatch({ type: USER_LOGOUT });
  dispatch({ type: USERS_RESET });
  dispatch({ type: DEPOT_ALL_RESET });
  dispatch({ type: PDF_RESET });
};

// medecin PS
export const login_M_PS = (username, password) => async (dispatch) => {
  try {
    dispatch({
      type: MEDECIN_PS_LOGIN_REQUEST,
    });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "auth",
      action: "loginMedecinPS",
      username: username,
      password: password,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    // console.log("data", data);
    if (data.success !== false) {
      dispatch({
        type: MEDECIN_PS_LOGIN_SUCCESS,
        payload: data,
      });
      localStorage.setItem("medecinPSInfo", JSON.stringify(data));
      localStorage.setItem("tokenMPS", JSON.stringify(data.tokenMPS));
    } else {
      dispatch({
        type: MEDECIN_PS_LOGIN_FAIL,
        payload: data.error,
      });
    }
  } catch (error) {
    console.log("error", error);
    console.log(error);
    dispatch({
      type: MEDECIN_PS_LOGIN_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const logout_Medecin_PS = () => async (dispatch) => {
  localStorage.removeItem("medecinPSInfo");
  localStorage.removeItem("tokenMPS");
  const inputs = {
    headers: {
      "Content-type": "application/json",
    },
    object: "auth",
    action: "logoutMedecinPS",
  };

  const { data } = await axios.post(BASE_URL, inputs);

  dispatch({ type: MEDECIN_PS_LOGOUT });
  dispatch({ type: MEDECIN_PS_RESET });
  dispatch({ type: PDFMPS_RESET });
};

//   export const addAdmin = (username, GradeState, is_staff, password) => async (
//       dispatch,
//       getState
//     ) => {
//     try {
//       dispatch({ type: USER_ADD_REQUEST });
//       const {
//         userLogin: { userInfo },
//       } = getState();

//       const config = {
//         headers: {
//           "Content-type": "application/json",
//           Authorization: `Bearer ${userInfo.token}`,
//         },
//       };
//       is_staff==='false' ? is_staff=false : is_staff=true
//       const { data } = await axios.post(
//         "http://127.0.0.1:8000/api/users/add/",
//         {
//           username: username,
//           GradeState: GradeState,
//           is_staff: is_staff,
//           password: password
//         },
//         config
//       );
//       dispatch({
//         type: USER_ADD_SUCCESS,
//         payload: data,
//       });

//     } catch (error) {
//       dispatch({
//         type: USER_ADD_FAIL,
//         payload:
//           error.response && error.response.data.detail
//             ? error.response.data.detail
//             : error.message,
//       });
//     }
//   };

//   export const listUsers = () => async (dispatch, getState) => {
//     try {
//       dispatch({ type: USER_ALL_REQUEST });

//       const {
//         userLogin: { userInfo },
//       } = getState();

//       const config = {
//         headers: {
//           "Content-type": "application/json",
//           Authorization: `Bearer ${userInfo.token}`,
//         },
//       };
//       const { data } = await axios.get(
//         `http://127.0.0.1:8000/api/users/`,
//         config
//       );
//       dispatch({
//         type: USER_ALL_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: USER_ALL_FAIL,
//         payload:
//           error.response && error.response.data.detail
//             ? error.response.data.detail
//             : error.message,
//       });
//     }
//   };

//   export const deleteUser = (id) => async (dispatch, getState) => {
//     try {
//       dispatch({
//         type: USERS_DELETE_REQUEST,
//       });
//       const {
//         userLogin: { userInfo },
//       } = getState();
//       const config = {
//         headers: {
//           "Content-type": "application/json",
//           Authorization: `Bearer ${userInfo.token}`,
//         },
//       };
//       const { data } = await axios.delete(
//         `http://127.0.0.1:8000/api/users/delete/${id}/`,
//         config
//       );
//       dispatch({
//         type: USERS_DELETE_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: USERS_DELETE_FAIL,
//         payload:
//           error.response && error.response.data.detail
//             ? error.response.data.detail
//             : error.message,
//       });
//     }
//   };

//   export const getUsersDetail = (id) => async (dispatch, getState) => {
//     try {
//       dispatch({
//         type: USERS_DETAIL_REQUEST,
//       });
//       const {
//         userLogin: { userInfo },
//       } = getState();
//       const config = {
//         headers: {
//           "Content-type": "application/json",
//           Authorization: `Bearer ${userInfo.token}`,
//         },
//       };
//       const { data } = await axios.get(`http://127.0.0.1:8000/api/users/detail/${id}/`, config);
//       dispatch({
//         type: USERS_DETAIL_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: USERS_DETAIL_FAIL,
//         payload:
//           error.response && error.response.data.detail
//             ? error.response.data.detail
//             : error.message,
//       });
//     }
//   };

//   export const updateUser = (user) => async (dispatch, getState) => {
//       try {
//           dispatch({
//               type: USER_UPDATE_REQUEST
//           })
//           const {
//               userLogin: { userInfo },
//           } = getState()
//           const config = {
//               headers: {
//                   'Content-type': 'application/json',
//                   Authorization: `Bearer ${userInfo.token}`
//               }
//           }
//           const { data } = await axios.put(
//               `http://127.0.0.1:8000/api/users/update/`,
//               user,
//               config
//           )
//           dispatch({
//               type: USER_UPDATE_SUCCESS,
//               payload: data
//           })
//           // dispatch({
//           //     type: USER_UPDATE_RESET,
//           //     payload: data
//           // })

//       } catch (error) {
//           dispatch({
//               type: USER_UPDATE_FAIL,
//               payload: error.response && error.response.data.detail
//                   ? error.response.data.detail
//                   : error.message,
//           })
//       }
//   }
